import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Button, Form, Input, Modal } from "antd";

import Swal from "sweetalert2";

import partnersApi from "../../apis/Partners.api";
import { setUser } from "../../redux/store/auth/authDuck";
import { toastAlert } from "../AlertComponent";

const EditSearchExample = ({ getInfo, user, setIsChange }) => {
	const dispatch = useDispatch();
	const isLoading = useSelector((state) => state.common.loading);
	const [placeholder, setPlaceholder] = useState("");

	const [exampleModal, setExampleModal] = useState(false);
	const [example, setExample] = useState("");

	useEffect(() => {
		setPlaceholder(user?.placeholder);
	}, [user]);

	useEffect(() => {
		if (placeholder !== user?.placeholder) {
			setIsChange(true);
		}
	}, [placeholder]);

	/**
	 * 검색 예시 수정
	 * @returns {Promise<void>}
	 */
	const submitSearchExample = async () => {
		let param = {
			...user,
			placeholder: placeholder,
		};
		if (user?.role !== "level_1") {
			param = {
				...param,
				id: user?.partners_id,
			};
		}
		const res = await partnersApi.editUserLink(param);
		if (res.code === 200) {
			Swal.fire({
				customClass: "alert-custom",
				text: "성공적으로 문구 수정이 완료되었습니다.",
				confirmButtonText: "확인",
			}).then(() => {
				getInfo();
				dispatch(
					setUser({
						...user,
						placeholder: placeholder,
					})
				);
			});
		} else {
			toastAlert("error: 적용이 실패되었습니다.");
		}
	};

	return (
		<div style={{ display: "flex", flexDirection: "column" }}>
			<div
				className={`edit-profile-channel`}
				style={{
					alignItems: "flex-start",
				}}
			>
				{/* 검색 예시 */}
				<div className={`edit-channel-component`}>
					<Form>
						<div className={`form-title`}>
							<p className={`title`}>검색 예시</p>
							<p
								className={`example`}
								onClick={() => {
									setExampleModal(true);
									setExample("search");
								}}
							>
								예시
							</p>
						</div>
						<div className={`edit-channel-component-body`}>
							<Form.Item
								label={`검색 예시`}
								colon={false}
								style={{
									width: "100%",
									margin: 0,
								}}
								labelAlign="left"
								labelCol={{ span: 4 }}
								wrapperCol={{ span: 22 }}
								className={`form-with-border`}
							>
								<Input
									type={`text`}
									placeholder={`검색 예시를 입력해주세요.`}
									allowClear={true}
									// defaultValue={item}
									value={placeholder}
									onChange={(e) => setPlaceholder(e.currentTarget.value)}
								/>
							</Form.Item>

							<div className={`example-keyword-div`}>
								<p>표기 예시</p>
								<Form.Item
									label={`PC`}
									colon={false}
									style={{
										width: "100%",
										margin: 0,
									}}
									labelAlign="left"
									labelCol={{ span: 3 }}
									wrapperCol={{ span: 21 }}
									className={`example-keyword-form`}
								>
									<Input
										type={`text`}
										placeholder={`PC 검색 예시`}
										disabled={true}
										style={{
											backgroundColor: "#f1f3f5",
											// color: "rgba(0, 0, 0, 0.5)",
											maxWidth: "80%",
										}}
										value={`증상, 영양제 검색하기 (예시: ${
											placeholder ? placeholder : "비타민"
										})`}
									/>
								</Form.Item>
								<Form.Item
									label={`모바일`}
									colon={false}
									style={{
										width: "100%",
										margin: 0,
									}}
									labelAlign="left"
									labelCol={{ span: 3 }}
									wrapperCol={{ span: 21 }}
									className={`example-keyword-form`}
								>
									<Input
										type={`text`}
										placeholder={`모바일 검색 예시`}
										disabled={true}
										style={{
											backgroundColor: "#f1f3f5",
											maxWidth: "60%",
										}}
										value={`검색 예시) ${placeholder ? placeholder : "비타민"}`}
									/>
								</Form.Item>
							</div>
						</div>
					</Form>
				</div>
			</div>

			<Button
				size={"small"}
				className={`edit-success-btn`}
				style={{
					// borderRadius: "5px",
					// width: "50%",
					margin: "1em auto",
					padding: "0.3em 1.5em",
					height: "auto",
				}}
				loading={isLoading}
				onClick={submitSearchExample}
			>
				적용하기
			</Button>

			<Modal
				title="검색 예시"
				wrapClassName="sms-send-modal"
				open={exampleModal}
				centered={true}
				onCancel={() => {
					setExampleModal(!exampleModal);
				}}
				width="60%"
				footer={null}
				style={{
					maxWidth: 900,
				}}
			>
				<img
					src={`/assets/images/landing/${example}.jpg`}
					alt={`예시 모달`}
					style={{
						height: "auto",
						width: "100%",
					}}
				/>
			</Modal>
		</div>
	);
};
export default EditSearchExample;
